<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import KeyValueMenu from '../KeyValueMenu/KeyValueMenu.vue';
import DropDownMenu from '../DropdownMenu/DropdownMenu.vue';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        KeyValueMenu,
        DropDownMenu,
        Fake
    },
    data () {
        return {
            selectedSite: undefined,
            selectedAccommodation: undefined
        }
    },
    computed: {
        ...mapState({
            sites: state => state.allocation.form.filters.sites,
            loading: state => state.allocation.form.filters.loading,
            error: state => state.allocation.form.filters.error,
            selected: state => state.allocation.form.filters.selected,
            years: state => state.allocation.allocations.years.years,
            currentYear: state => state.allocation.allocations.years.current
        }),
        ...mapGetters({
            routeSiteNames: 'allocation/routeSiteNames',
            routeAccommodationNames: 'allocation/routeAccommodationNames'
        })
    },
    methods: {
        ...mapActions({
            setSelectedRouteFilters: 'allocation/setSelectedRouteFilters',
            updateYear: 'allocation/updateYear'
        }),
        updateRoute (obj) {
            this.setSelectedRouteFilters(obj).then(() => {
                // If setting the site parameter then set accommodations to all
                if (obj.hasOwnProperty('site')) {
                    this.setSelectedRouteFilters({site: obj.site, accommodation: undefined});
                } else {
                    this.$router.push('/dashboard/allocation-management/' + this.selected.site.id + '/' + obj.accommodation.accommodationSiteId);
                }
            })
        }
    }
}
</script>
<template>
    <div class="manage-allocation-filters">
        <div v-if="!loading" class="manage-allocation-filters__body">
            <div class="manage-allocation-filters__option">
                <key-value-menu :label="'Site'"
                                :value="selected.site"
                                :items="routeSiteNames"
                                @input="updateRoute({site: $event})"/>
            </div>
            <div class="manage-allocation-filters__option">
                <key-value-menu :label="'Accommodation'"
                                :value="selected.accommodation"
                                :items="routeAccommodationNames"
                                :disabled="loading"
                                :key="'allocations-filters-accommodation-' + routeAccommodationNames"
                                @input="updateRoute({accommodation: $event})"/>
            </div>
            <div class="manage-allocation-filters__option">
                <drop-down-menu :label="$t('manageAllocationFilters.year')"
                                :value="currentYear"
                                :items="years"
                                :searchable="false"
                                @input="updateYear($event)"/>
            </div>
        </div>
        <fake v-if="loading"
              :body-rows="1"
              :body-cells="4"
              :key="'fake'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationFilters/ManageAllocationFilters.vue